import { Moon, Sun } from 'lucide-react';
import {useDarkMode} from "../../contexts/DarkmodeContext";

const DarkModeToggle = () => {
    const { theme, toggleTheme } = useDarkMode();

    return (
        <button
            onClick={toggleTheme}
            className="p-2 rounded-lg hover:bg-neutral-100 dark:hover:bg-neutral-700 transition-colors"
            aria-label="Toggle dark mode"
        >
            {theme === 'dark' ? (
                <Sun className="h-5 w-5 text-yellow-500" />
            ) : (
                <Moon className="h-5 w-5 text-neutral-600" />
            )}
        </button>
    );
};

export default DarkModeToggle;
